import IComponent from "./IComponent";
import "./SwitchTabs.scoped.css";

class SwitchTabs extends IComponent {
  constructor(props) {
    super(props);
    console.debug(props);
    // activedTab: true = Left, false = Right
    this.state = {
      activedTab: props.activedTab || 0,
      horizonBarIsVisible: false,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      typeof this.props.activedTab !== "undefined" &&
      prevProps.activedTab !== this.props.activedTab
    ) {
      this.setState({
        activedTab: this.props.activedTab,
      });
    }
  }

  switchTab(activedTab, tabTitle) {
    this.setState({ activedTab });
    if (this.props.onSwitchTabCallback) {
      let returnVal = this.props.onSwitchTabCallback(activedTab, tabTitle);
      if (returnVal) this.setState({ activedTab: -1 });
    }
  }

  render() {
    return (
      <div className="switchTabContainer" style={this.props.style || {}}>
        <div
          className={this.props.isIconTabs ? "imagetabs" : "tabs"}
          style={
            false
              ? { height: "calc(var(--formElementSize) + 10px)" }
              : { height: "var(--formElementSize)" }
          }
        >
          {this.props.tabText.map((i, j) => (
            <div
              key={j}
              className={this.state.activedTab == j ? "actived" : ""}
              // style={
              //   this.props.tabText.length == 2
              //     ? { width: "50%" }
              //     : typeof i !== "string"
              //     ? { width: 100 / this.props.tabText.length + "%" }
              //     : /*j==this.props.tabText.length-1?{flex: "auto", padding: "0px 30px"}:*/ {
              //         width: i.length * 10 + 20 + "px",
              //       }
              // }
              // style={
              //   i &&
              //   ((i.length > 13 && this.props.tabText.length > 6) ||
              //     (i.length > 15 &&
              //       this.props.tabText.length > 4 &&
              //       this.props.tabText.length <= 6))
              //     ? { lineHeight: "25px" }
              //     : {}
              // }
              onClick={() => this.switchTab(j, i)}
            >
              <span>
                {this.props.isIconTabs ? <span className={`icon_s ${i}`} /> : i}
              </span>
            </div>
          ))}
        </div>
        {/* {this.props.children?.length && <div style={{ marginTop: "20px" }} />} */}
        {this.props.children && (
          <div className="contentSection" style={{ background: "white" }}>
            {this.props.children?.[this.state.activedTab]}
          </div>
        )}
      </div>
    );
  }
}

export default SwitchTabs;
